export default "__VITE_ASSET__CLKl7gpT__"